'use strict'

exports.util = require('./util.js')
exports.resolver = require('./resolver.js')



//////////////////
// WEBPACK FOOTER
// ./~/ipld-eth-block-list/src/index.js
// module id = 554
// module chunks = 0